<template>
    <div>
        <label class="control-label">E-Lock {{lockNumber}}</label>
        <button v-if="visible && !lockState.is_main_entrance && !lockState.grantBtnState" @click="unreached(lockState.lock)" type="button" class="btn btn-xs btn-warning float-end" :disabled="lockState.unreachedDisabled">Unreached</button>
        <button v-if="visible && !lockState.grantBtnState" @click="showErrorDropdown(lockState.lock)" type="button" class="btn btn-xs btn-danger float-end h-margin-10" :disabled="lockState.errorBtnDisabled"> Error </button>
        <button v-if="visible && !lockState.grantBtnState" @click="unlock(lockState.lock)" class="btn btn-xs btn-light float-end" type="button" :disabled="lockState.tryAgainDisabled">Try Again</button>
        <button v-if="visible && lockState.grantBtnState"  @click="grant(lockState.lock)" class="btn btn-xs btn-light float-end" type="button" :disabled="lockState.grantBtnDisabled">Grant</button>

        <span v-if="lockState.unlocking" class="spinner anim-spin float-end h-margin-10"></span>

        <multiselect
            :disabled="dropdownVisible && lockState.lock && !lockState.grantBtnState"
            v-model="selectedLock"
            :options="selectableLocks"
            track-by="id"
            label="label"
            placeholder="Choose lock"
            group-values="locks"
            group-label="name"
            :allow-empty="true"
            :multiple="false"
            :close-on-select="true"
            :style="{ height: 'auto'}"
        />

        <label v-if="lockState.errorBtnClicked"
               class="control-label">E-Lock {{lockNumber}}: Solution Provided</label>
        <multiselect
            v-if="lockState.errorBtnClicked"
            v-model="errorDropdown"
            :options="errorOptions"
            track-by="id"
            label="label"
            placeholder="Choose Reason"
            style="margin-bottom: 20px;"
            :allow-empty="true"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :style="{ height: 'auto'}"
        />
    </div>
</template>

<script>

import Multiselect from "vue-multiselect";
import {EventBus} from "../../EventBus";
import API from "../../Services/API";
import Endpoints from "../../Config/Endpoints";

export default {
    name: "ELockComponent",
    components: {
        Multiselect
    },
    emits: ['update:lockStates'],
    mounted() {
        EventBus.on("error-selected", this.showErrorDropdown)
    },
    props: {
        remoteAccessId: {
            type: Number,
        },
        lockId: {
            type: String,
            required: true
        },
        lockNumber: {
            type: Number,
            required: true
        },
        visible: {
            type: Boolean,
            default: false,
        },
        dropdownVisible: {
            type: Boolean,
            default: true,
        },
        selectableLocks: {
            type: Array,
            required: true
        },
        lockStates:{
            type: Object,
            required: true
        }
    },
    data: function() {
        return {
            errorDropdown: null,
            errorOptions: [
                {id:'redirected_to_another_centre', label:'Redirected to another centre'},
                {id:'make_another_booking', label:'Make another booking, change office'},
                {id:'knock_on_the_door', label:'Knock on the door, someone inside opens door'},
                {id:'cancel_booking_and_credit_the_customer', label:'Cancel booking and credit the customer'}
            ]
        }
    },
    computed: {
        lockState() {
            return this.lockStates[this.lockId] || {};
        },
        selectedLock: {
            get() {
                return this.lockState.lock || null;
            },
            set(newValue) {
                this.updateLockState({
                    lock: newValue,
                    grantBtnDisabled: !newValue,
                });
            }
        }
    },
    methods: {
        updateLockState(updates) {
            const newLockStates = {
                ...this.lockStates,
                [this.lockId]: {
                    ...this.lockState,
                    ...updates
                }
            };
            this.$emit('update:lockStates', newLockStates);
        },
        unlock(lock) {
            EventBus.emit('unlock', { lock, lockId: this.lockId });
        },
        grant(lock) {
            this.unlock(lock);
            this.updateLockState({ grantBtnState: false });
        },
        async error(lock, reason){
            await axios.post(
                API.url(Endpoints.RemoteAccess.Error,{ remote_access_id: this.remoteAccessId, lock_id: lock.id }),
                { reason: reason }
            );
        },
        async unreached(lock) {
            this.updateLockState({
                unreachedDisabled: true,
                tryAgainDisabled: true,
                isUnreached: true
            });

            await axios.post(
                API.url(Endpoints.RemoteAccess.Unreached,{ remote_access_id: this.remoteAccessId, lock_id: lock.id })
            );
        },
        showErrorDropdown: function (lock){
            const newLockStates = { ...this.lockStates };
            Object.keys(newLockStates).forEach(lockId => {
                if (newLockStates[lockId].lock) {
                    newLockStates[lockId] = {
                        ...newLockStates[lockId],
                        errorBtnDisabled: true
                    };
                }
            });

            if (newLockStates[this.lockId]) {
                newLockStates[this.lockId] = {
                    ...newLockStates[this.lockId],
                    unreachedDisabled: true,
                    tryAgainDisabled: true,
                    errorBtnClicked: true
                };
            }

            this.$emit('update:lockStates', newLockStates);

            if(lock.solution !== null){
                this.errorDropdown = this.errorOptions.find(o => o.id === lock.solution);
            }
            EventBus.emit('error-btn-clicked');
        }
    },
    watch: {
        errorDropdown(){
            if (!this.lockState.errorBtnClicked || !this.errorDropdown) {
                return;
            }

            this.error(this.lockState.lock, this.errorDropdown.id);
            EventBus.emit('error-reason-selected');
        }
    }
}
</script>

<style scoped>

.btn-warning{
    font-weight: bold;
    text-transform: uppercase;
}
.btn-warning:disabled{
    background-color: #f2f2f2;
    border-color: #dedede;
    color: #d2d3d3;
    font-weight: bold;
}
</style>
